import { useTranslation } from "react-i18next";
import { licenseQuestionKey, loginQuestionKey } from "@/engine/questions";
import type { WizardAnswers } from "@/types";

function CheckCircleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-3.5 h-3.5 text-green-500 shrink-0"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

function BriefcaseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-3.5 h-3.5 text-ink-50"
      aria-hidden="true"
    >
      <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      <rect width="20" height="14" x="2" y="6" rx="2" />
    </svg>
  );
}

interface WizardReviewProps {
  visible: string[];
  answers: WizardAnswers;
  formatAnswer: (id: string) => string;
}

export function WizardReview({ visible, answers, formatAnswer }: WizardReviewProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <div className="rounded-lg border border-ink-10 px-4 py-2.5 flex items-center justify-between">
        <p className="text-xs text-muted-foreground">{t("wizard.review.orgType")}</p>
        <p className="font-medium text-sm capitalize flex items-center gap-2">
          <BriefcaseIcon />
          {t("wizard.customerType.workplace.label")}
        </p>
      </div>
      {visible.map((id) => (
        <div
          key={id}
          className="rounded-lg border border-ink-10 px-4 py-2.5 flex items-center justify-between gap-4"
        >
          <p className="text-xs text-muted-foreground">
            {id === "rw_license"
              ? t(`wizard.steps.rw_license.${licenseQuestionKey(answers)}`)
              : id === "login_method"
                ? t(`wizard.steps.login_method.${loginQuestionKey(answers)}`)
                : t(`wizard.steps.${id}.question`)}
          </p>
          <p className="font-medium text-sm flex items-center gap-2 text-right">
            <CheckCircleIcon />
            {formatAnswer(id)}
          </p>
        </div>
      ))}
    </div>
  );
}
